import React from 'react';

import './loading.css';

const Loading = () => {
  return (
    <div className="loading-container">
      <h1 id="loading-header">...Loading next player</h1>
    </div>
  )
}

export default Loading;
